export default __webpack_public_path__ + "static/media/user.7b98ed01.svg";